import React, { Suspense } from 'react';

import { ContentSet } from 'components/Shared/Scaffolding';
import Panel, { PanelTitle } from 'components/Shared/Panel';
import AdvancedForm from 'components/AdvancedSettings/AdvancedForm';
import { SCAFFOLDING } from 'theme';
import withCancel from 'components/Shared/PanelCancel';
import { SmallLoading } from 'components/Loading/SmallLoading';

const AdvancedPanel = ({ open, onClose, onCancel }) => (
    <Panel open={open} onClose={onCancel}>
        <ContentSet spacing={SCAFFOLDING.GUTTER} padding={SCAFFOLDING.GUTTER}>
            <PanelTitle>Advanced Settings</PanelTitle>
            <Suspense fallback={<SmallLoading size={40} />}>
                <AdvancedForm closePanel={onClose} cancelPanel={onCancel} />
            </Suspense>
        </ContentSet>
    </Panel>
);

export default withCancel({ form: 'advanced-form' })(AdvancedPanel);
